import { Grid, Typography } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import { Helmet } from "react-helmet-async";
import {
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { studentArticles } from "./Help";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "70px",
  },
  rootbase: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: `calc(100vh - 200px)`,
      overflow: "visible",
    },
  },
  faqTopics: {
    backgroundColor: "#f7f7f7",
    height: "100vh",
    paddingLeft: "50px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    overflow: "scroll",

    "& li": {
      color: "#646f79",
      listStyleType: "none",
      margin: "15px 10px",
      fontWeight: "600",
      fontSize: "16px",
      padding: "5px ",
    },
    "& li:hover": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& li.active": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      paddingTop: "20px",
      paddingLeft: "10px",
    },
  },
  faqWrapper: {
    paddingTop: "60px",
    position: "sticky",
    height: `calc(100% - 70px)`,
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      padding: "0 10px",
    },
  },
  fontHeading: {
    color: "#646f79",
    textDecoration: "underline",
    fontWeight: 700,
  },
  hyperlink: {
    color: "#8277FF !important",
    textDecoration: "none",
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 0 0 1.5px #646f79",
    display: "flex",
    flexWrap: "nowrap",
    margin: "10px 20px 40px 0px",
  },
  searchIcon: {
    height: "100%",
    position: "relative",
    display: "flex",
    alignSelf: "center",
    right: "10px",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
  },
  categoryMain: {
    width: "100%",
    height: `calc(100vh - 70px)`,
    overflow: "auto",
    paddingLeft: "30px",
    paddingBottom: "30px",
    paddingRight: "10px",
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      overflow: "visible",
    },
  },
  catLink: {
    color: "#4381b5",
    display: "table",
    marginTop: "20px",
  },
  subCat: {
    marginTop: "40px",
    textDecoration: "underline",
    color: "#646f79",
    "&:after": {
      content: '":"',
    },
  },
  topicSubCat: {
    textDecoration: "underline",
    color: "#646f79",
  },
  arrowIcon: {
    fontSize: "14px",
    color: "#9287FF",
    marginRight: "7px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#9287FF",
  },
  catList: {
    padding: "0px",
  },
}));

function GettingStarted() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Getting started</Typography>
      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {studentArticles
        .filter((article) => article.Category === "Getting started")
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/getting-started-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function TakingAssessments() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Taking assessments</Typography>
      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {studentArticles
        .filter((article) => article.Category === "Taking assessments")
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/taking-assessments-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function HelpOptionsStudent() {
  const { url, path } = useRouteMatch();

  const location = useLocation();
  const { pathname } = location;

  const allOptions = studentArticles;

  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          Help Topics, Tips and Resources to Learn More About SwiftGrade
        </title>
        <meta
          name="description"
          content="SwiftGrade can grade both paper and online assessments making it great for virtual, in-person, or hybrid learning. Helping teachers reduce grading load for handwritten assessments by 80-90%."
        />
      </Helmet>
      <div className={classes.rootbase}>
        <Grid container>
          <Grid item xs={12} sm={3} className={classes.faqTopics}>
            <div className={classes.faqWrapper}>
              <Grid container direction="row" alignItems="center">
                <Link
                  to={`/`}
                  style={{ display: "flex" }}
                  className={classes.breadcrumb}
                >
                  <ArrowBackIcon className={classes.arrowIcon} />
                </Link>
                <Link
                  to={`/`}
                  style={{ textDecoration: "none" }}
                  className={classes.breadcrumb}
                >
                  Help Center
                </Link>
              </Grid>
              <Autocomplete
                id="complete"
                options={allOptions}
                openOnFocus={true}
                getOptionLabel={(option) => option.Topic}
                renderOption={(option) => (
                  <Link
                    style={{
                      width: "100%",
                      color: "black",
                      height: "100%",
                      textDecoration: "none",
                    }}
                    to={`/help-topics/${option.Sublink}/${option.Link}`}
                  >
                    <div
                      style={{
                        height: "100%",
                        margin: "5px 0px 5px 20px",
                      }}
                    >
                      {option.Topic}
                    </div>
                  </Link>
                )}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref} className={classes.search}>
                    <InputBase
                      {...params.inputProps}
                      placeholder="Search"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ "aria-label": "search" }}
                    />
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div>
                  </div>
                )}
              />
              <ul className={classes.catList} id="topicList">
                <Link
                  to={`${url}/getting-started`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("getting-started") ? "active" : ""
                    }
                  >
                    Getting started
                  </li>
                </Link>
                <Link
                  to={`${url}/taking-assessments`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("taking-assessments") ? "active" : ""
                    }
                  >
                    Taking assessments
                  </li>
                </Link>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} sm={9} className={classes.categoryMain}>
            <Switch>
              <Route exact path={`${path}`}>
                <Redirect to="student-help/getting-started" />
              </Route>
              <Route exact path={`${path}/getting-started`}>
                <GettingStarted />
              </Route>
              <Route path={`${path}/taking-assessments`}>
                <TakingAssessments />
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default HelpOptionsStudent;
